import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5_66)">
      <path
        d="M160.8 96.5C174.8 113.5 191.8 127.4 210.3 138.7C236.2 154.5 264 164.6 288 170.3V138.8C265.8 108.5 250 71.5 248.6 28C248.2 16.7 241.1 6.5 230.2 3.6C222.6 1.6 214.4 3.4 209.2 9.4C195.9 24.8 176.5 54 160.8 96.6V96.5ZM320 144V174.6V175.9V208C259.2 202.9 135 164.2 100.7 50.8C97.4 40 87.9 32 76.6 32C68.7 32 61.3 35.9 57.8 43C46.8 65.9 32 112.1 32 176C32 292.9 112.1 356.5 150.4 378.8L11.8 416.6C6.70001 418 2.6 421.8 0.900005 426.8C-0.799996 431.8 0.100005 437.4 3.2 441.6C21.7 466.2 77.3 512 160 512C163.6 512 167.2 510.8 170 508.5L245.6 448H320C408.4 448 480 376.4 480 288V128L509.9 83.1C511.2 81.1 512 78.7 512 76.3C512 69.5 506.5 64 499.7 64H400C355.8 64 320 99.8 320 144ZM400 128C404.243 128 408.313 129.686 411.314 132.686C414.314 135.687 416 139.757 416 144C416 148.243 414.314 152.313 411.314 155.314C408.313 158.314 404.243 160 400 160C395.757 160 391.687 158.314 388.686 155.314C385.686 152.313 384 148.243 384 144C384 139.757 385.686 135.687 388.686 132.686C391.687 129.686 395.757 128 400 128Z"
        fill="#8803E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_66">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
